var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "renderer" },
    [
      _c(
        "router-link",
        { attrs: { to: _vm.link } },
        [
          _c("ProfileIcon", {
            staticClass: "mr-2",
            staticStyle: { "font-size": ".90em" },
            attrs: { icon: _vm.object.meta.icon },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "name" }, [
            _vm._v(_vm._s(_vm.object.meta.name)),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }